export default {
    init() {
        $(document).ready(function () {
          //INSIGHTS
            $('body').on('keyup', '#search-insights', function (event) {
                let search = $(this).val().trim();

                if ('URLSearchParams' in window && event.keyCode === 13) {
                    if (search.length !== 0) {
                        let searchParams = new URLSearchParams(window.location.search);
                        searchParams.set('search', search.toString());
                        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                        history.pushState(null, '', newRelativePathQuery);
                    } else {
                      // eslint-disable-next-line no-undef
                        removeQueryString('search');
                    }

                    location.reload();
                }
            });
            $('#insight-category-select').on('change', function () {
                let category = $(this).val();

                if (category.length !== 0) {
                    window.location = category;
                } else {
                    window.location.href = '/insights';
                }
                // if ('URLSearchParams' in window) {
                //     // let searchParams = new URLSearchParams(window.location.search);
                //
                //     if (category.length !== 0) {
                //         // searchParams.set('cat', category.toString());
                //         // let newRelativePathQuery = '/insights' + '?' + searchParams.toString();
                //         let newRelativePathQuery = '/insights/' + category;
                //         console.log(newRelativePathQuery);
                //         history.pushState(null, '', newRelativePathQuery);
                //     } else {
                //         removeQueryString('cat');
                //     }
                //
                //     location.reload();
                // }
            });
        });

    function removeQueryString(queryString)
    {
        let url = new URL(window.location.href);
        let searchParams = new URLSearchParams(url.search)
        searchParams.delete(queryString);

        let newRelativePathQuery = window.location.pathname + (searchParams.toString().length > 0 ? '?' + searchParams.toString() : '');
        history.pushState(null, '', newRelativePathQuery);
    }
    },
    finalize() {
    },
};
